import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number
  height?: number
  color?: Color
}

const ArrowLeftSvg = ({ width, height, color, ...rest }: Props) => (
  <svg width={width} height={height} viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M3.09677 6L7.6129 1.96154C8.12903 1.5 8.12903 0.807692 7.6129 0.346154C7.09677 -0.115385 6.32258 -0.115385 5.80645 0.346154L0.387097 5.19231C-0.129032 5.65385 -0.129032 6.34615 0.387097 6.80769L5.80645 11.6538C6.06452 11.8846 6.32258 12 6.70968 12C7.09677 12 7.35484 11.8846 7.6129 11.6538C8.12903 11.1923 8.12903 10.5 7.6129 10.0385L3.09677 6Z"
      fill={color}
    />
  </svg>
)

ArrowLeftSvg.defaultProps = {
  width: 12,
  height: 8,
  color: colors.Primary.GreyText,
}

export default ArrowLeftSvg
